import React from 'react'
import { makeStyles } from '@material-ui/styles'
import {
  Paper, Stack,
} from '@material-ui/core'
import { Logo, LogoContainer, SearchField } from '../Atoms'
import { ButtonCollection } from '../Molecules'

const useStyles = makeStyles(theme => ({
  main: {
    position: "relative",
    height: "100%",
    width: "100%",
  },
  content: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -70%)",
    [theme.breakpoints.up('xl')]: {
      width: "40%"
    },
    [theme.breakpoints.down('lg')]: {
      width: "40%"
    },
    [theme.breakpoints.down('md')]: {
      width: "50%"
    },
    [theme.breakpoints.down('sm')]: {
      width: "90%"
    },
    display: "flex",
    alignItems: "center",
    flexDirection: "column"
  },
  search: {
    marginTop: "1rem !important"
  },
  button: {
    marginTop: "2rem !important"
  },
  buttonCollection: {
    position: "absolute",
    right: 48,
    top: 0,
    zIndex: 100
  }
}))

const Home = () => {
  const classes = useStyles()

  return (
    <LogoContainer>
      <div className={classes.buttonCollection}>
        <ButtonCollection />
      </div>
      <Stack direction="row" justifyContent='center' alignItems='center' style={{ height: "100vh" }}>
        <div className={classes.main}>
          <div className={classes.content}>
            <Logo
              style={{ maxWidth: "90%" }}
            />
            <br />
            <Paper
              elevation={3}
              style={{ padding: 5 }}
            >
              <SearchField />
            </Paper>
          </div>
        </div>
      </Stack>
    </LogoContainer>
  )
}

export default Home
